import { j as t } from "./jsx-runtime-DmTjM30f.js";
import { useContext as b, useState as i, useEffect as I } from "react";
import { AppContext as st } from "./AppContext.js";
import { F as it } from "./provider-Diwup2pn.js";
import { LoginContext as rt } from "./LoginContext.js";
import { P as f, a as at, b as lt, D as ct } from "./index.esm-G8KyR0tM.js";
import { u as dt } from "./useConfiguration-B-lyaBB9.js";
import { r as M } from "./sentry-CAR5o4wv.js";
import { r as mt } from "./MandateListing-D8XscYA_.js";
import { i as L, H as pt, B as ft } from "./utils-D5LKKDAj.js";
import { i as n } from "./index-wI714H_N.js";
import { o as ut } from "./redirection-8g5vvfzH.js";
import { W as ht } from "./Welcome-C4-GwyyJ.js";
import { A as gt } from "./Auth-BeDpKAhM.js";
import { P as _t } from "./PartnerLogin-BdkPSQka.js";
import { P as xt, a as Pt } from "./PlansListing-Da9pH_5R.js";
import { ErrorPage as jt } from "./ErrorPage.js";
import { E as wt, P as yt, S as St } from "./StopPlanStatus-fKwGVM1R.js";
function Ut({ isGroupInvestment: k, mandate_id: W, isPartner: P }) {
  var O;
  const { loggedInPartner: z } = b(rt), { AppState: { showWelcomePage: A, tenant: B }, setShowWelcomePage: R } = b(st), { fpapi: a } = b(it), [j, N] = i({}), [T, C] = i(F), [U, u] = i(!1), [c, v] = i({}), [G, l] = i("initial"), [D, w] = i(!1), [H, J] = i({}), [h, g] = i(!1), [K, q] = i({}), [d, $] = i(null), V = ({ pan: e }) => {
    $(e);
  }, Y = [
    {
      step: 1,
      content: n._({
        id: "1ddmub"
      })
    },
    {
      step: 2,
      content: n._({
        id: "2l2YJx"
      })
    },
    {
      step: 3,
      content: n._({
        id: "05nr9e"
      })
    }
  ], { tenantConfig: m } = dt();
  (O = m == null ? void 0 : m.groupInvestment) == null || O.allowedEmailDomains, I(() => {
    (async () => {
      if (a && d)
        try {
          u(!0);
          const e = a.fpClient.investor_profiles().fetchAll({
            pan: d
          }), o = a.fpClient.mf_investment_accounts().fetchAll({
            investor: d
          }), [r, s] = await Promise.all([
            e,
            o
          ]), _ = r == null ? void 0 : r.data[0], x = s == null ? void 0 : s.data[0];
          if (!x || !_) {
            u(!1);
            return;
          }
          N(_), q(x);
        } catch (e) {
          window.debug.error(e), M(e);
        } finally {
          u(!1);
        }
      else
        u(!1);
    })();
  }, [
    d
  ]);
  const Z = () => {
    l("initial"), g(!h);
  }, Q = () => {
    l("initial"), g(!h);
  }, X = async (e, o) => {
    var r;
    if ((o == null ? void 0 : o.provider_name) === "BILLDESK")
      ut(e == null ? void 0 : e.token_url, "mandate-billdesk", () => Z(), () => Q());
    else
      try {
        const { emailData: s, phoneData: _ } = await a.fetchEmailAndPhone(j), x = {
          amount: 0,
          currency: "INR",
          method: "emandate",
          bank: "ICIC",
          email: s.email,
          contact: _.number,
          order_id: (r = e.sdk_options) == null ? void 0 : r.order_id,
          customer_id: e.sdk_options.customer_id
        }, S = mt(e.sdk_options.key);
        S.createPayment(x), S.on("payment.success", function(p) {
          a.submitPayment(e.sdk_options.callback_url, p.razorpay_payment_id, p.razorpay_order_id, p.razorpay_signature).then(() => {
            l("initial"), g(!h);
          });
        }), S.on("payment.error", function(p) {
          a.submitPaymentError(e.sdk_options.callback_url, "error", p.error.code, p.error.description).then(() => {
            l("initial"), g(!h);
          });
        });
      } catch (s) {
        window.debug.log(s.message), M(s);
      }
  };
  function E(e) {
    var r;
    if (P) {
      window.open(pt(B) + `/mandates?id=${e == null ? void 0 : e.id}`, "_blank", "noopener=true");
      return;
    }
    u(!0);
    const o = {
      mandate_id: e == null ? void 0 : e.id
    };
    ((r = m == null ? void 0 : m.app_constants) == null ? void 0 : r.paymentGateway) === "BILLDESK" && (o.payment_postback_url = `${window.location.origin + ft}/redirection`), a.fpClient.mandates().authorize(o).then(async (s) => {
      X(s, e);
    });
  }
  const y = () => {
    l("initial");
  }, tt = () => /* @__PURE__ */ t.jsx(lt, {
    variant: "fullPage",
    title: n._({
      id: "eVF0Ns"
    }),
    contentHeightMax: !0,
    isOpen: D,
    toggleModal: () => {
      w(!1);
    },
    children: /* @__PURE__ */ t.jsx(xt, {
      investorProfile: j,
      currentPlanObject: H,
      handleAuthorize: E,
      onModifySuccess: (e, o) => {
        w(!1), v(e), l(o);
      },
      isGroupInvestment: k,
      isPartner: P,
      assistedWorkflowPAN: d
    })
  });
  function et() {
    switch (G) {
      default:
        return /* @__PURE__ */ t.jsx(t.Fragment, {});
      case "initial":
        return /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            /* @__PURE__ */ t.jsx(f, {
              title: n._({
                id: "2yU70/"
              })
            }),
            /* @__PURE__ */ t.jsx(ct, {
              type: "text",
              text: n._({
                id: "t9eDJH"
              })
            }),
            /* @__PURE__ */ t.jsx(Pt, {
              investorProfile: j,
              isGroupInvestment: k,
              mandate_id: W,
              mfInvestmentAccount: K,
              onModifySuccess: (e, o) => {
                v(e), l(o);
              },
              togglePlanDetailsModal: (e) => {
                w(!D), J(e);
              },
              handleAuthorize: E,
              isPartner: P
            })
          ]
        });
      case "stop_finished":
        return !L(c) && /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            /* @__PURE__ */ t.jsx(f, {
              title: n._({
                id: "RGK6hg"
              })
            }),
            /* @__PURE__ */ t.jsx(St, {
              currentPlanObject: c,
              handleGoToPlansList: y
            })
          ]
        });
      case "pause_finished":
        return !L(c) && /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            /* @__PURE__ */ t.jsx(f, {
              title: n._({
                id: "qqCDUS"
              })
            }),
            /* @__PURE__ */ t.jsx(yt, {
              pauseOrder: c,
              handleGoToPlansList: y
            })
          ]
        });
      case "edit_finished":
        return !L(c) && /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            /* @__PURE__ */ t.jsx(f, {
              title: n._({
                id: "LBzlW2"
              })
            }),
            /* @__PURE__ */ t.jsx(wt, {
              editOrder: c,
              handleGoToPlansList: y
            })
          ]
        });
      case "invalid_email_domain":
        return /* @__PURE__ */ t.jsx(jt, {
          title: n._({
            id: "ISwZlJ"
          }),
          description: n._({
            id: "lwG6FE"
          }),
          showDetails: !1
        });
    }
  }
  I(() => {
    C(F());
  }, [
    A
  ]);
  function F() {
    return A ? "welcome" : "plansList";
  }
  function nt() {
    R(!1), C("plansList");
  }
  function ot() {
    return T === "welcome" ? /* @__PURE__ */ t.jsxs(t.Fragment, {
      children: [
        /* @__PURE__ */ t.jsx(f, {
          title: n._({
            id: "SynB8s"
          })
        }),
        /* @__PURE__ */ t.jsx(ht, {
          onAck: nt,
          welcomeSteps: Y
        })
      ]
    }) : /* @__PURE__ */ t.jsx(t.Fragment, {
      children: /* @__PURE__ */ t.jsx("div", {
        className: "mb-20",
        children: U ? /* @__PURE__ */ t.jsx(at, {
          variant: "fullpage"
        }) : z ? d ? /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            et(),
            tt()
          ]
        }) : /* @__PURE__ */ t.jsx(gt, {
          onPreviewData: V,
          allowRegistration: !1,
          isPartner: !0,
          redirectURL: window.location.href,
          showTestPan: {
            onboarded: !0,
            kycCompliant: !1,
            kycNonCompliant: !1
          }
        }) : /* @__PURE__ */ t.jsxs(t.Fragment, {
          children: [
            /* @__PURE__ */ t.jsx(f, {
              title: n._({
                id: "SynB8s"
              })
            }),
            /* @__PURE__ */ t.jsx(_t, {
              context: window.location.href
            })
          ]
        })
      })
    });
  }
  return /* @__PURE__ */ t.jsx(t.Fragment, {
    children: ot()
  });
}
export {
  Ut as AssistedPlansList
};
